(() => {
  'use strict';
  if (window.parent !== window || /\/pages\/planner\/?$/.test(location.pathname)) return;
  let active = null;
  const style = document.createElement('style');
  style.textContent = `.optisofa-planner-overlay{position:fixed;inset:0;margin:0;border:0;padding:0;width:100%;max-width:none;height:100%;height:100dvh;max-height:none;background:white;overflow:hidden;transform:translateY(0);isolation:isolate}.optisofa-planner-overlay.is-open{transform:translateY(0)}.optisofa-planner-overlay::backdrop{background:transparent;opacity:0;transition:none;animation:none}.optisofa-planner-overlay shopify-overlay-planner-helper>iframe{display:block;border:0;width:100%;height:100%}.optisofa-planner-overlay>button{position:absolute;right:8px;top:calc(var(--overlay-announcement-height,0px) + 8px);width:44px;height:44px;border:0;background:white;color:black;display:grid;place-items:center;z-index:3;cursor:pointer}.optisofa-planner-overlay [market-switcher-trigger]{display:none!important}@media(min-width:761px){.optisofa-planner-overlay>button{right:12px;top:calc(var(--overlay-announcement-height,0px) + 20px)}}.optisofa-planner-overlay.is-ready>button,.optisofa-planner-overlay.is-ready .optisofa-overlay-loading{display:none}.optisofa-overlay-loading{position:absolute;inset:0;display:grid;place-items:center;background:white;z-index:1}.optisofa-overlay-loading span{width:24px;height:24px;border:2px solid #d1d2f0;border-top-color:#222;border-radius:50%;animation:optisofa-overlay-spin .8s linear infinite}@keyframes optisofa-overlay-spin{to{transform:rotate(360deg)}}@media(prefers-reduced-motion:reduce){.optisofa-overlay-loading span{animation:none}}@media(prefers-reduced-motion:reduce){.optisofa-planner-overlay{transition:none}}`;
  document.head.append(style);
  function open(url, push = true) {
    if (active) return;
    const scroll = {x:scrollX,y:scrollY};
    const focus = document.activeElement;
    const bodyStyle = document.body.getAttribute('style');
    const htmlScroll = document.documentElement.style.scrollBehavior;
    const dialog = document.createElement('dialog');
    dialog.className = 'optisofa-planner-overlay';
    dialog.setAttribute('aria-label', document.documentElement.lang.startsWith('de') ? 'Sofa konfigurieren' : 'Konfigurator sofy');
    const frame = document.createElement('iframe');
    frame.title = dialog.getAttribute('aria-label');
    frame.allow = 'clipboard-write; fullscreen; xr-spatial-tracking';
    const target = new URL(url);
    target.searchParams.set('planner_overlay','1');
    target.searchParams.set('return_url', location.href);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) target.searchParams.set('preview_theme_id',preview);
    const helper = document.createElement('shopify-overlay-planner-helper');
    helper.dataset.url = target.href;
    helper.dataset.deferStart = 'true';
    helper.style.cssText='display:block;width:100%;height:100%';
    helper.append(frame);
    const close = document.createElement('button');
    close.type='button'; close.innerHTML='<svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true"><path d="M4.5835 4.58334L17.4168 17.4167M17.4168 4.58334L4.5835 17.4167" stroke="currentColor" stroke-width="1.14583" stroke-linecap="round"/></svg>'; close.setAttribute('aria-label',document.documentElement.lang.startsWith('pl')?'Zamknij':document.documentElement.lang.startsWith('de')?'Schließen':'Close');
    close.onclick = () => dismiss(true);
    const viewport=document.createElement('div');
    viewport.style.cssText='position:absolute;inset:0;overflow:hidden';
    const loading=document.createElement('div');
    loading.className='optisofa-overlay-loading';
    loading.setAttribute('role','status');
    loading.setAttribute('aria-label',document.documentElement.lang.startsWith('pl')?'Ładowanie konfiguratora':document.documentElement.lang.startsWith('de')?'Konfigurator wird geladen':'Loading configurator');
    loading.innerHTML='<span aria-hidden="true"></span>';
    viewport.append(helper,loading);
    frame.addEventListener('load',()=>{
      if(new URL(frame.src || 'about:blank').origin === 'https://planner.optisofa.com') dialog.classList.add('is-ready');
    });
    dialog.append(viewport,close);
    const token = (!push && history.state?.optisofaOverlay?.token) || Date.now() + '-' + Math.random().toString(36).slice(2);
    active = {dialog,frame,scroll,focus,bodyStyle,htmlScroll,token,closing:false};
    const state = active;
    if(push) history.pushState({...history.state,optisofaOverlay:{url:url.href || url,token}},'',location.href);
    document.body.style.position='fixed'; document.body.style.top=`-${scroll.y}px`;
    document.body.style.left=`-${scroll.x}px`; document.body.style.width='100%';
    document.body.append(dialog); dialog.showModal();
    const announcement=document.querySelector('body > .header-container__top') || [...document.querySelectorAll('.header-container__top')].find(el=>!dialog.contains(el));
    if(announcement && announcement.getBoundingClientRect().height > 0) {
      const placeholder=document.createElement('div');
      placeholder.style.height=announcement.getBoundingClientRect().height+'px';
      announcement.before(placeholder);
      active.announcement={element:announcement,placeholder,style:announcement.getAttribute('style')};
      announcement.style.cssText+=';position:absolute;top:0;left:0;right:0;width:100%;z-index:2';
      dialog.append(announcement);
      const sync=()=>{
        const height=announcement.getBoundingClientRect().height;
        placeholder.style.height=height+'px';
        viewport.style.top=height+'px';
        dialog.style.setProperty('--overlay-announcement-height',height+'px');
        helper.style.height='calc(100% + 40px)';
        helper.style.transform='translateY(-40px)';
      };
      sync();
      active.announcement.observer=new ResizeObserver(sync);
      active.announcement.observer.observe(announcement);
    }
    const chat = document.getElementById('gorgias-chat-container');
    if (chat) {active.chat = chat; active.chatParent=chat.parentNode; active.chatNext=chat.nextSibling;dialog.append(chat)}
    dialog.addEventListener('optisofa-overlay-close', () => dismiss(true));
    dialog.addEventListener('cancel', event => {event.preventDefault();dismiss(true)});
    dialog.classList.add('is-open');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    dialog.style.willChange='transform, opacity';
    state.motion = dialog.animate([
      {transform:'translate3d(0,32px,0)',opacity:0},
      {transform:'translate3d(0,0,0)',opacity:1}
    ], {duration:reduced ? 0 : 220,easing:'cubic-bezier(.2,.7,.2,1)',fill:'both'});
    state.motion.finished.then(() => {
      if(active !== state || state.closing) return;
      state.motion.cancel(); state.motion=null;
      dialog.style.willChange='auto';
      helper.start();
    }).catch(()=>{});
  }
  function dismiss(back) {
    const state=active;
    if (!state || state.closing) return;
    state.closing=true;
    const current=getComputedStyle(state.dialog);
    const from={transform:current.transform,opacity:current.opacity};
    state.motion?.cancel();
    state.dialog.style.willChange='transform, opacity';
    let finished=false;
    function finish() {
      if(finished) return; finished=true;
      if(state.chat && state.chatParent?.isConnected) state.chatParent.insertBefore(state.chat,state.chatNext?.parentNode === state.chatParent ? state.chatNext : null);
      if(state.announcement) {
        const {element,placeholder,style,observer}=state.announcement;
        observer.disconnect();
        placeholder.replaceWith(element);
        if(style === null) element.removeAttribute('style'); else element.setAttribute('style',style);
      }
      state.dialog.close(); state.dialog.remove();
      document.documentElement.classList.remove('planner-chat-custom');
      if(state.bodyStyle === null) document.body.removeAttribute('style'); else document.body.setAttribute('style',state.bodyStyle);
      document.documentElement.style.scrollBehavior='auto';
      window.scrollTo(state.scroll.x,state.scroll.y);
      document.documentElement.style.scrollBehavior=state.htmlScroll;
      state.focus?.focus?.({preventScroll:true});
      active=null;
      if(back && history.state?.optisofaOverlay?.token === state.token) history.back();
    }
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduced) {finish();return;}
    state.motion=state.dialog.animate([
      from,{transform:'translate3d(0,20px,0)',opacity:0}
    ],{duration:140,easing:'cubic-bezier(.4,0,1,1)',fill:'forwards'});
    state.motion.finished.then(finish,finish);
  }
  document.addEventListener('click', event => {
    if(event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link=event.target.closest('a[href]');
    if(!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    let url; try {url=new URL(link.href)} catch{return}
    if(url.origin !== location.origin || !/\/pages\/planner\/?$/.test(url.pathname)) return;
    event.preventDefault(); event.stopImmediatePropagation(); open(url);
  },true);
  window.addEventListener('message',event => {
    if(!active || event.source !== active.frame.contentWindow) return;
    if(!['https://optisofa-planner-production.up.railway.app','https://planner.optisofa.com'].includes(event.origin)) return;
    if(event.data?.type === 'planner:exit:cover' || event.data?.type === 'planner:close') {
      event.stopImmediatePropagation();
      event.source.postMessage({type:event.data.type === 'planner:exit:cover' ? 'planner:exit:covered' : 'planner:closing'},event.origin);
      dismiss(true);
    }
    if(event.data?.type === 'planner:loaded') active.dialog.classList.add('is-ready');
  },true);
  window.addEventListener('popstate',event => {
    if(active) dismiss(false);
    else if(event.state?.optisofaOverlay) open(event.state.optisofaOverlay.url,false);
  });
})();
